import React from 'react'
import PropTypes from 'prop-types'

import { useMakeSelector } from 'hooks/redux'
import {
  QUERY_INPUT_TYPES,
  TIMER,
  SWITCH_INPUT,
  SERVICE,
} from 'utils/constants'
import InputSignalSelector from 'components/feature/NavigatorPanes/editors/base/InputSignalSelector'
import Circuit from 'components/feature/Harnesses/Circuit'
import FixedOrFloatingEditor from 'components/feature/NavigatorPanes/editors/FixedOrFloatingEditor'
import { makeSignalSelector } from 'selectors/feature/inputs'
import { propOr } from 'ramda'

import { schemaProp } from 'schemas/validation'
import conditionSchema from 'schemas/validation/feature/conditionSchema'

import { OutputControlHelper } from 'components/feature/NavigatorPanes/OutputNodePane/OutputNodeEditor/OutputControlSection/OutputControlSelection/OutputControlSelection'
import InputTypeEditor from '../InputTypeEditor'
import withStyle from './InputSelectionEditor.style'

const rule = schemaProp(conditionSchema)
const { DIGITAL_INPUT, CAN_INPUT, ANALOG_INPUT } = QUERY_INPUT_TYPES

const InputSelectionEditor = ({
  className,
  switchSingleConditionType,
  isSixteenBitCanOutput,
  parentQueryUri,
  uri,
  isSingleCondition,
  featureModuleName,
  subType: originalSubtype,
  fnId,
  signal,
  parentType,
  conditionIndex,
  showHarnesses,
  floatingCircuit,
  onInputChange,
  inputUri,
  output,
  disabled,
}) => {
  const currentSignal = useMakeSelector(makeSignalSelector, {
    signal: inputUri,
  })
  const isSwitchSignal = propOr([], 'switches', currentSignal).length > 0
  const subType = isSwitchSignal ? SWITCH_INPUT : originalSubtype
  const showCircuit =
    showHarnesses && (subType === ANALOG_INPUT || subType === DIGITAL_INPUT)
  const hasParent = parentQueryUri !== undefined && parentQueryUri !== ''
  const showOutputControlHelper =
    subType !== CAN_INPUT && !hasParent && output?.type === SERVICE
  return (
    <span className={className}>
      <InputTypeEditor
        currentValue={subType}
        onTypeChange={switchSingleConditionType}
        disabled={disabled}
      />
      {showOutputControlHelper && <OutputControlHelper />}

      {subType !== CAN_INPUT && (
        <FixedOrFloatingEditor
          floatingValue={floatingCircuit}
          onFloatingChange={onInputChange}
          floatingActive={showCircuit}
          floatingRules={rule('floatingCircuit')}
          subType={subType}
        >
          <InputSignalSelector
            showLabel={!showCircuit}
            selectedType={subType}
            fnId={fnId}
            isNativeOutput={output?.type === SERVICE}
            parentQueryUri={parentQueryUri}
            uri={uri}
            featureModuleName={featureModuleName}
            isTimerActivateCondition={
              parentType === TIMER && conditionIndex === 0
            }
            onInputChange={onInputChange}
          />
          {showCircuit && <Circuit id={signal} />}
        </FixedOrFloatingEditor>
      )}
    </span>
  )
}

InputSelectionEditor.propTypes = {
  className: PropTypes.string,
  switchSingleConditionType: PropTypes.func,
  selectedInputUri: PropTypes.string,
  parentQueryUri: PropTypes.string,
  uri: PropTypes.string,
  inputOptions: PropTypes.object,
  setAsCanInput: PropTypes.func,
  isSixteenBitCanOutput: PropTypes.bool,
  query: PropTypes.shape({
    queryType: PropTypes.string,
    subType: PropTypes.string,
    fnId: PropTypes.string,
    signal: PropTypes.string,
    floatingCircuit: PropTypes.string,
  }),
  output: PropTypes.shape({
    type: PropTypes.string,
  }),
  disabled: PropTypes.object,
  isSingleCondition: PropTypes.bool,
  featureModuleName: PropTypes.string,
  onInputChange: PropTypes.func,
  showHarnesses: PropTypes.bool,
  subType: PropTypes.string,
  fnId: PropTypes.string,
  signal: PropTypes.string,
  parentType: PropTypes.string,
  conditionIndex: PropTypes.number,
  floatingCircuit: PropTypes.string,
  inputUri: PropTypes.string,
}

export default withStyle(InputSelectionEditor)
